import { ORG_Account_UserAccess } from 'src/app/models/SYSCore/ORG_Account_UserAccess';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { branch } from 'src/app/models/branch';
import { calender_days } from 'src/app/models/calender_days';
import { UserAuthedDTO } from 'src/app/models/DTO/UserAuthedDTO';
import { employeeInfo } from 'src/app/models/employeeInfo';
import { VehiclesInfo } from 'src/app/models/fleet/VehiclesInfo';
import { ORG_Account_Branch } from 'src/app/models/SYSCore/ORG_Account_Branch';
import { ORG_Account_Addressplace } from 'src/app/models/SYSCore/ORG_Account_Addressplace';

@Injectable({
  providedIn: 'root'
})
export class SharingDataAppServiceService {


  constructor() { }


  private branchsList = new BehaviorSubject<ORG_Account_Branch[]>([]);
  branch$: Observable<ORG_Account_Branch[]> = this.branchsList.asObservable();
  SetbranchsList(Model: ORG_Account_Branch[]) {
    this.branchsList.next(Model);
  }

  private adresbookList = new BehaviorSubject<ORG_Account_Addressplace[]>([]);
  adresbook$: Observable<ORG_Account_Addressplace[]> = this.adresbookList.asObservable();
  SetadresbookList(Model: ORG_Account_Addressplace[]) {
    this.adresbookList.next(Model);
  }


  private employeeInfosList = new BehaviorSubject<employeeInfo[]>([]);
  employeeInfo$: Observable<employeeInfo[]> = this.employeeInfosList.asObservable();
  SetemployeeInfosList(Model: employeeInfo[]) {
    this.employeeInfosList.next(Model);
  }

  private calenderDays = new BehaviorSubject<calender_days[]>([]);
  calnderdaysYear$: Observable<calender_days[]> = this.calenderDays.asObservable();
  SetcalenderDaysList(Model: calender_days[]) {
    this.calenderDays.next(Model);
  }
  private vehiclesInfosList= new BehaviorSubject<VehiclesInfo[]>([]);
  Vehicles$: Observable<VehiclesInfo[]> = this.vehiclesInfosList.asObservable();
  SetVehiclesInfo(Model: VehiclesInfo[]) {
    this.vehiclesInfosList.next(Model);
  }
  private UserMetaData= new BehaviorSubject<UserAuthedDTO>(null);
  UserMeta$: Observable<UserAuthedDTO> = this.UserMetaData.asObservable();
  SetUserMetaData(Model: UserAuthedDTO) {
    this.UserMetaData.next(Model);
  }

   private UserAccessListData= new BehaviorSubject<ORG_Account_UserAccess[]>(null);
   UserAccessList$: Observable<ORG_Account_UserAccess[]> = this.UserAccessListData.asObservable();
   SetUserAccessListData(Model: ORG_Account_UserAccess[]) {
    this.UserAccessListData.next(Model);
  }
}
